import { AbsoluteCenter, Box, Flex, Heading, Spinner, Stack } from "@chakra-ui/react";
import { ErrorPage } from "../Error";
import { PageLoader } from "../../components/shared/PageLoader";
import { useLoadingPageFlow } from "../../components/features/LoginPage/LoadingPage/hooks";
import type { LoaderFunction } from "react-router-dom";
import { redirect } from "react-router-dom";
import { RoutesMap } from "../../routes.tsx";
import { usePersistStore } from "../../store/persistStore";
import { EJWTStatus, validateJWT } from "../../utils";
import { queryClient } from "../../api";
import { limitsQueryConfig } from "../../api";

function ProcessingLimitScreen() {
  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={9} minW="300px">
          <div>
            <Heading fontSize={20} mb={2} textAlign="center">
              Обрабатываем вашу
              <br />
              заявку
            </Heading>
          </div>
          <Flex alignItems="center" justifyContent="center" mt={16}>
            <Spinner variant="white" />
          </Flex>
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

export function LoadingPage() {
  const flow = useLoadingPageFlow();

  switch (flow.view) {
    case "error":
      return <ErrorPage />;
    case "processing":
      return <ProcessingLimitScreen />;
    case "loader":
    default:
      return <PageLoader />;
  }
}

const loadingPageLoader: LoaderFunction = async () => {
  const { jwt } = usePersistStore.getState();
  if (!jwt || validateJWT(jwt) === EJWTStatus.Invalid) {
    return redirect(RoutesMap.login.index);
  }

  try {
    await queryClient.fetchQuery({
      ...limitsQueryConfig(),
      staleTime: 0,
    });
  } catch (_e) {
    // Includes 401 / NetworkError etc.
    return redirect(RoutesMap.login.index);
  }

  return null;
};

LoadingPage.loader = loadingPageLoader;
